import {useCallback, useEffect} from 'react';
import {useViewport} from './useViewport';
import {useZoomOnly} from '../hooks/useZoomOnly';
import {useReactFlow} from '@xyflow/react';
import {useGetActiveScreenId} from '@features/activeScreenIdContext/useGetActiveScreenId';
import {isEditableElementFocused} from '@features/utils/dom';
import {useIsEditingTextRef} from '@features/frame/partialEdit/atoms';
import {ZoomControls} from './ZoomControls';

export const Zoom = () => {
  const scale = useZoomOnly();
  const {zoomIn, zoomOut, fitViewToChat, fitViewToAll} = useViewport();
  const reactFlow = useReactFlow();
  const getActiveScreenId = useGetActiveScreenId();
  const isEditingTextRef = useIsEditingTextRef();

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (isEditableElementFocused()) return;
      if (isEditingTextRef.current) return;

      if (event.key === '=' || event.key === '+') {
        void zoomIn();
        return;
      }
      if (event.key === '-') {
        void zoomOut();
        return;
      }
    },
    [zoomIn, zoomOut, isEditingTextRef],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <ZoomControls
      scale={scale}
      onZoomIn={() => void zoomIn()}
      onZoomOut={() => void zoomOut()}
      onZoomToFit={() => void fitViewToAll({duration: 0})}
      onZoomToPercentage={(p) => void reactFlow.zoomTo(p / 100, {duration: 0})}
      onZoomToSelected={() => {
        const activeScreenId = getActiveScreenId();
        if (activeScreenId) {
          void fitViewToChat(activeScreenId, {duration: 0});
        }
      }}
    />
  );
};
